import { ReactNode } from "react";
import { clsx } from "clsx";

interface CardProps {
  title?: string;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
  noPadding?: boolean;
}

export const Card = ({
  title,
  description,
  actions,
  children,
  className,
  bodyClassName,
  noPadding,
}: CardProps) => {
  return (
    <div className={clsx("card", className)}>
      {(title || description || actions) && (
        <div className="card-h">
          <div>
            {title && <h2>{title}</h2>}
            {description && <p>{description}</p>}
          </div>
          {actions && <div className="r">{actions}</div>}
        </div>
      )}
      <div className={clsx("card-b", noPadding && "flush", bodyClassName)}>{children}</div>
    </div>
  );
};

export default Card;
